/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { UpdateCourseSectionOrderOptions, UpdateCourseSectionOrderResponses } from '../../models/UpdateCourseSectionOrder'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Update Course Section Order
 * {@link /admin/course/:course_id/sections/:section_id/set-order/:index}
 */
export function updateCourseSectionOrder<ThrowOnError extends boolean = true>(options: Options<UpdateCourseSectionOrderOptions, ThrowOnError>): Promise<UnwrappedResult<UpdateCourseSectionOrderResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'PUT', url: '/admin/course/{course_id}/sections/{section_id}/set-order/{index}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<UpdateCourseSectionOrderResponses, ThrowOnError>>
}
